import Cookie from 'js-cookie';

// ported & refactored from ATCMS:
// https://github.com/apartmenttherapy/atcms/blob/master/app/assets/javascripts/site/helpers/VisitorHelper.js

export const COOKIE_NAME = 'originating_source';
export const COOKIE_EXPIRATION_IN_DAYS = 30;

// double-backslashes are so that the backslash makes it to the RegExp
// constructor so that we can specify a literal period.
export const REFERRING_SITE_REGEXPS = Object.entries({
  facebook: '(www\\.)?facebook\\.com',
  twitter: '(t\\.co|(www\\.)?twitter\\.com)',
  pinterest: '(www\\.)?pinterest\\.com',
  instagram: '(www\\.)?instagram\\.com',
  google_search: '(www\\.)?google(\\.com?)?\\.[a-z]{2,3}',
  marketplace: '(www\\.)?marketplace\\.apartmenttherapy\\.com'
}).reduce(
  (acc, [siteKey, siteRegex]) =>
    Object.assign({}, acc, {
      [siteKey]: new RegExp(`^https?://${siteRegex}`)
    }),
  {}
);

/**
 * Returns friendly name of passed URL, or just the hostname if no match exists.
 * If no referer is passed, returns an empty string.
 *
 * @param {String} referringUrl URL of referring document
 * @returns {String} friendly referrer name
 */
export function getFriendlyReferrer(referringUrl) {
  let referrer = '';

  const currentUrl = window.location.href;

  if (referringUrl) {
    const referringHost = new URL(referringUrl).hostname;
    const currentHost = new URL(currentUrl).hostname;

    if (referringHost === currentHost) {
      referrer = 'internal';
    } else {
      const site = Object.entries(REFERRING_SITE_REGEXPS).find(
        ([_, siteRegex]) => siteRegex.test(referringUrl)
      );

      referrer = site ? site[0] : referringHost;
    }
  }

  return referrer;
}

/**
 * Returns the visitor's originating source from the existing cookie, if it
 * exists. If not, calculates it based on the passed referrer and any present
 * utm_* params in the query string.
 *
 * @param referrer friendly referrer name, from getFriendlyReferrer()
 * @return {String} calculated originating source
 */
export function getOriginatingSource(referrer) {
  // CLEANUP: this is not factored very well.
  const persistedSource = Cookie.get(COOKIE_NAME);
  if (persistedSource) {
    // Originating source is already set, keep it
    return persistedSource;
  }

  const currentUrl = new URL(window.location.href);
  const utmCampaign = currentUrl.searchParams.get('utm_campaign');
  const utmSource = currentUrl.searchParams.get('utm_source');

  if (utmCampaign) {
    return `${utmCampaign} / ${utmSource || ''}`;
  }

  if (['none', 'internal'].includes(referrer)) {
    return 'direct';
  }

  // Use the hostname
  return referrer;
}

/**
 * sets or updates the originating source cookie with the value of getOriginatingSource
 * babsed on the passed docR
 *
 * @export
 * @param {String} referringUrl referring document URL
 */
export function setCookie(referringUrl) {
  // CLEANUP: this is not factored very well.
  const referrer = getFriendlyReferrer(referringUrl);
  const originatingSource = getOriginatingSource(referrer);

  // Create a cookie for "Originating Source", or renew its expiration.
  Cookie.set(COOKIE_NAME, originatingSource, {
    expires: COOKIE_EXPIRATION_IN_DAYS,
    path: '/'
  });
}
